module.exports = __webpack_public_path__ + "img/7_73.70c583fd.png";